import React, { useEffect, useState, useContext } from 'react'

import { gameId, gameIdDiversion } from '../../../constants/activity-constants'
import userSessionStorage from '../../../utils/userSessionStorage'
import GameServices from '../../../services/game-service'
import { Link, navigate } from 'gatsby'
import { Context } from '../../../context/app-context'

import genial from '../../../assets/images/modals/genial.svg'
import videoImg from '../../../assets/images/modals/video.png'
import './modalEndGame.scss'
import pushEventDataLayer from '../../../utils/pushEventDataLayer'


const ModalEndGame = ({ dataGames }) => {

  const [points, setPoints] = useState(0)
  const [session] = useState(new userSessionStorage())
  const { dispatch, modalActive } = useContext(Context)

  useEffect(() => {
    let sumPoints = 0
    dataGames.forEach(data => {
      sumPoints += data.points
    })
    setPoints(sumPoints)

  }, [])

  useEffect(() => {
    handleTokenGameRedemption()
  }, [])


  //redimir participacion
  const handleTokenGameRedemption = async () => {
    let tokenParticipationSession = sessionStorage.getItem('tokenParticipation')

    let activityID = (sessionStorage.getItem('diversion') === 'true') ? gameIdDiversion : gameId


    let sumPoints = 0
    dataGames.forEach(data => {
      sumPoints += data.points
    })


    let payload = {
      point: sumPoints,
      tokenGame: tokenParticipationSession,
      gameId: activityID,
    }

    let tokenId = session.getToken().idToken

    let config = {
      headers: {
        Authorization: tokenId,
      },
    }
    try {
      const participationSaveResponse = await GameServices.postGameParticipationSave(
        payload,
        config,
      )
      sessionStorage.setItem('diversion', false)

    } catch (error) {
      console.log(error)
    }
  }

  const goTop = () => {
    pushEventDataLayer('Personajes :: Juego', 'Final juego', 'Ir al top')

    navigate('/top')
    dispatch({
      type: 'set',
      payload: {
        modalActive: null,
      },
    })

  }

  const goHome = () => {
    pushEventDataLayer('Personajes :: Juego', 'Final juego', 'Ir  al home')
    navigate('/')
    dispatch({
      type: 'set',
      payload: {
        modalActive: null,
      },
    })

  }
  const again = () => {
    pushEventDataLayer('Personajes :: Juego', 'Final juego', 'Volver a jugar')
    dispatch({
      type: 'set',
      payload: {
        modalActive: null,
      },
    })
    window.location.reload()
  }

  return (
    <div className='f-endgame-container'>
      <div className='f-endgame-container__wrapper'>
        <span className='f-modalRedeem-container__content__close' onClick={() => goHome()} />

        <div className='f-endgame-container__content'>
          <figure className='f-endgame-container__content-img'>
            <img src={genial} alt='genial' />

          </figure>

          <div className='f-endgame-container__content-info'>
            <div className='f-endgame-container__content-info-video'>
              <p className='txt-pink'>¡Siempre tenemos mucho que aprender!</p>
              <p>Para que hablemos sin pelos en la lengua, <b>dale play a este video</b></p>
              <a
                href='https://www.dropbox.com/s/6ld2spvpxj7hlif/01-23_VIDEO_EDUCATIVO_PUBERTAD_JM_MASTER_V4_SUB.mp4?dl=0'
                target='_blank'
              >
                <img src={videoImg} />
              </a>
            </div>
            <div className='f-endgame-container__content-info-txt'>


              {(sessionStorage.getItem('diversion') === 'true') ? (
                <>
                  <p>
                    <b className='pink'> Acumulaste</b> <b className='pink pink--bg'>{points} puntos</b> en este juego,
                  </p>
                  <p>¡Seguí jugando con Nosotras! No te detengas y participa las veces que quieras.</p>
                </>
              ) : (
                <>
                  <p>
                    <b className='pink'> Acumulaste</b> <b className='pink pink--bg'>{points} puntos</b> en este juego,
                    seguí participando.
                  </p>
                  <p>
                  Entre más jugués, más oportunidades tendrás de ganar
                  </p>
                  {/* <p>
                    <b> ¿Quieres ver si estás entre los mejores puntajes?</b> <a onClick={() => goTop()}>Haz clic
                    aquí.</a>

                  </p> */}
                </>
              )}

              <div className='f-endgame-container__content-info-txt-btn'>

                <button onClick={() => again()}>
                  VOLVER A JUGAR
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default ModalEndGame
